const makeInitialState = () => {
  return {
    emailList: ''
  };
};

export default makeInitialState;
